/* @flow */
import Backbone from 'backbone-collection';
import sync from './BackboneSync';

export default class Collection<TModel> extends Backbone.Collection<TModel> {
  add(models: TModel | Array<TModel>, options: Object = {}) {
    // Make add() use `merge` by default
    return super.add(models, Object.assign({ merge: true }, options));
  }

  fetch(options: Object = {}): any {
    return new Promise((resolve, reject) => {
      options.success = resolve;
      options.error = (model, response) => {
        reject(response);
      };
      super.fetch(options);
    });
  }

  // eslint-disable-next-line
  sync(...args: *[]) {
    return sync.apply(this, arguments);
  }

  jasmineToString(): string {
    // $FlowIssue
    return '[' + this.length + ' ' + this.model.name + 's]';
  }

  // $FlowFixMe missing annotation
  static fetch(options = {}): Promise<this> {
    return new this().fetch(options);
  }

  // $FlowFixMe missing annotation
  static fromJSON(models = []): this {
    // $FlowIssue
    return new this(models, { parse: true });
  }
}
